import api from '../../ApiConfig';
import { Apis } from '../../config';

var token = localStorage.getItem('userToken');
const getCoupons = async () => {
  try {

    let result = await api.get(Apis.GetCoupons, {
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return null;
  }
};

const getSingleCoupon = async (id) => {
  try {

    let result = await api.get(Apis.GetSingleCoupon+id, {
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return null;
  }
};

const createCoupon = async (data) => {
  try {

    let result = await api.post(Apis.CreateCoupons, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return null;
  }
};

const updateCoupon = async (id, data) => {
    try {
      let result = await api.put(`${Apis.UpdateCoupon + id}`, data,{
          headers: {
            'x-access-token': token,
          }
        });
      if (result.data.error) {
        return null;
      }
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return null;
    }
  };


  const deleteCoupon = async (id) => {
  try {

    let result = await api.delete(Apis.DeleteCoupon+id, {
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return null;
  }
};
const exportedObject = {
    getCoupons,
    getSingleCoupon,
    createCoupon,
    updateCoupon,
    deleteCoupon

};
export default exportedObject;